module.exports = __webpack_public_path__ + "static/media/persona-2.290d8a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/persona-2.png
// module id = 576
// module chunks = 0